import * as React from 'react';

export function SvgScissors() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.00302 3.37486C0.971444 5.16161 1.57735 7.44442 3.35512 8.48554L8.93106 11.9999L3.35511 15.5142C1.57735 16.5553 0.971446 18.8381 2.00302 20.6249C3.03856 22.4185 5.33202 23.033 7.12562 21.9975C8.91922 20.9619 9.53375 18.6685 8.49821 16.8749C8.20609 16.3689 7.81387 15.9568 7.36101 15.649L11.041 13.3297L11.0423 13.3305L13.1522 12.0007L13.1509 11.9999L22.3506 6.2016L21.1509 4.29812L11.041 10.6701L7.361 8.3507C7.81387 8.04297 8.20609 7.63083 8.49821 7.12486C9.53375 5.33127 8.91922 3.0378 7.12562 2.00227C5.33202 0.966734 3.03856 1.58127 2.00302 3.37486ZM3.95158 4.49986C3.53737 5.2173 3.78318 6.13469 4.50062 6.5489C5.21806 6.96311 6.13544 6.7173 6.54966 5.99986C6.96387 5.28242 6.71806 4.36504 6.00062 3.95082C5.28318 3.53661 4.36579 3.78242 3.95158 4.49986ZM4.50062 17.4508C3.78318 17.865 3.53737 18.7824 3.95158 19.4999C4.36579 20.2173 5.28318 20.4631 6.00062 20.0489C6.71806 19.6347 6.96387 18.7173 6.54966 17.9999C6.13544 17.2824 5.21806 17.0366 4.50062 17.4508Z"
          fill="currentColor"
        />
        <path
          d="M15.2621 13.3305L13.1522 14.6603L21.1509 19.7016L22.3506 17.7981L15.2621 13.3305Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
